<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M12 17.1c-.2-.1-.4-.4-.4-.7v-4c0-.5.3-.8.6-.8h4.6c.3 0 .6.4.6.8v4c0 .5-.3.8-.7.8-.6 0-1 .4-1 1s.5 1 1 1c1.5 0 2.6-1.2 2.6-2.8v-4c0-1.6-1.2-2.8-2.6-2.8h-4.6c-1.4 0-2.6 1.3-2.6 2.8v4c0 1.2.7 2.2 1.7 2.6.5.2 1.1-.1 1.3-.6.3-.5.1-1.1-.5-1.3z" />
        <path d="M21.3 13.6c-.5-.2-1.1.1-1.3.6-.2.5.1 1.1.6 1.3.2.1.4.4.4.7v4c0 .5-.3.8-.6.8h-4.6c-.3 0-.6-.4-.6-.8v-4c0-.5.3-.8.7-.8.6 0 1-.4 1-1s-.5-1-1-1c-1.5 0-2.6 1.2-2.6 2.8v4c0 1.6 1.2 2.8 2.6 2.8h4.6c1.4 0 2.6-1.3 2.6-2.8v-4c-.1-1.2-.8-2.2-1.8-2.6z" />
        <path d="M10.4 21.1H7.6V7.5h9.7v.1c0 .5.4 1 1 1s1-.4 1-1V3.5c0-1.4-1.1-2.5-2.5-2.5H3.5C2.1 1 1 2.1 1 3.5v17C1 21.9 2.1 23 3.5 23h6.9c.5 0 1-.4 1-1s-.5-.9-1-.9zm6.3-18.2c.3 0 .5.2.5.5v2H7.6V2.9h9.1zm-13.2 0h2.1v2.6H2.9v-2c0-.3.3-.6.6-.6zm0 18.2c-.3 0-.5-.2-.5-.5v-13h2.6v13.5H3.5z" />
      </g>
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';
const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);
onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>
<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
